<template>
  <Modal
    ref="modalRef"
    model-value
    :title="$t('region_not_available.title')"
  >
    <div class="region-modal column gap-16 q-mb-16 q-px-16 q-px-md-32">
      <div
        class="with-link"
        v-html="$t('region_not_available.description', { link })"
      />
      <div class="column gap-8">
        <q-btn
          color="orange"
          :href="link"
          :label="$t('button.go_to_gettransfer')"
          unelevated
        />
        <q-btn
          :label="$t('button.stay_here')"
          flat
          @click="$refs.modalRef.hide()"
        />
      </div>
    </div>
  </Modal>
</template>

<script setup>
import Modal from '~components/Modal';

const link = 'https://gettransfer.com/transfers/new?utm_source=rideclu&utm_medium=web&utm_campaign=no_service';
</script>

<style lang="scss" scoped>
$orange: #f66a03;

.bg-orange {
  background: $orange !important;
}

.region-modal {
  max-width: 95vw;
  width: 450px;
}

.with-link :deep(a) {
  color: $orange;
}
</style>
